var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card my-3 px-3 py-3"},[_c('h5',{staticStyle:{"color":"#000","align-self":"center"}},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('apexchart',{attrs:{"type":"bar","options":!_vm.incoming ? _vm.chartOptions : _vm.chartOptionsCalls,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }